var React = require('react');

function EnvelopeIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z","key":0}),React.createElement("path",{"d":"M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z","key":1})]);
}

EnvelopeIconInline.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","fill":"#269C74"};

module.exports = EnvelopeIconInline;

EnvelopeIconInline.default = EnvelopeIconInline;
